import { Link } from "react-router-dom";
import MiniPreview from "./MiniPreview";
import { Tag } from "./Ui";

export default function CaseCard({ cs, large = false }) {
  return (
    <Link
      to={`/case-studies/${cs.id}`}
      data-testid={`case-card-${cs.id}`}
      className="group flex h-full flex-col overflow-hidden rounded-2xl border border-line bg-white transition-all duration-200 hover:-translate-y-1 hover:border-accent"
    >
      <MiniPreview visual={cs.visual} />
      <div className="flex flex-1 flex-col p-6 lg:p-8">
        <div className="flex flex-wrap items-center gap-2">
          <span className="rounded-full bg-plum px-3 py-1 font-mono text-[10px] uppercase tracking-[0.16em] text-white">
            {cs.area}
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.16em] text-muted">
            Professional experience · anonymised
          </span>
        </div>
        <h3 className={`mt-4 font-serif font-medium leading-snug text-ink ${large ? "text-xl sm:text-2xl" : "text-lg"}`}>
          {cs.title}
        </h3>
        <p className="mt-3 flex-1 text-sm leading-relaxed text-muted">{cs.summary}</p>
        <ul className="mt-4 flex flex-wrap gap-2">
          {cs.tools.slice(0, 3).map((t) => (
            <li key={t}><Tag>{t}</Tag></li>
          ))}
        </ul>
        <span className="mt-6 text-sm font-semibold text-plum group-hover:text-accent">
          Explore case study →
        </span>
      </div>
    </Link>
  );
}
